module.exports = __webpack_public_path__ + "img/capa-juntos-10.73489940.png";